import { all } from "redux-saga/effects";
import sagaUtils from "../sagaUtils";
import circuitRequestFunctions from "./circuitRequestFunctions";

export default function* rootSaga() {
  yield all(sagaUtils.extractRequestFunctions(circuitRequestFunctions));
}
